import { Outlet } from "react-router-dom";
import { ZendeskWidget } from "src/components/ZendeskWidget";
import { useLoggedInAppSetup } from "src/hooks/useLoggedInAppSetup";
import { AppProviders } from "src/routing/components/AppProviders";
import { RouteEnvironmentProviders } from "src/routing/components/RouteEnvironment";

/**
 * Logged-in provider + Zendesk/analytics stack with `<Outlet/>`.
 *
 * Used by `AppShell` and `NotFoundShell` after the auth gate, and by `AppShellProviders` in tests/stories.
 * Zendesk stays inside `AppProviders` (notifications context). Layout choice is per sibling branch below.
 */
export function AuthenticatedShell() {
  useLoggedInAppSetup();

  return (
    <RouteEnvironmentProviders>
      <AppProviders>
        <ZendeskWidget />
        <Outlet />
      </AppProviders>
    </RouteEnvironmentProviders>
  );
}
